export default __webpack_public_path__ + "static/media/ESGIcon.47a9ac48.PNG";